<script>
    import {
        getEncounterClaimStatusTooltip,
        showEncounterPendingClaimTooltip,
    } from "../../../../../Pages/PatientEncounter/helpers/encounterHelper.svelte";

    import { apiMethods } from "../../../../../Services/index.svelte";

    import { claimStatus, RoleType } from "../../../../../Utils/utilEnums.svelte";

    import {
        getClaimStatus,
        showError,
    } from "../../../../../Utils/utilFunctions.svelte";

    import {
        CustomTooltip,
        NotificationModal,
        TableComponentContainer,
    } from "../../../../Common/index.svelte";

    export let row = {};
    export let onStatusChange = () => {};

    let showStatusDropdown = false;
    let dropdownPosition = { top: 0, left: 0 };

    let selectedStatus,
        showUpdateStatusModal = false,
        isUpdatingClaimStatus = false;

    $: invoiceSent = row.invoices && row.invoices.length > 0 && row.invoices.some((i) => i.status == 2);

    const updateEncounterClaimStatus = async () => {
        isUpdatingClaimStatus = true;

        await apiMethods.putMethod
            .updateClaimStatus(row.id, selectedStatus)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to update encounter claim status, please refresh the page and try again and contact support if the issue persists.",
                    );
                else onStatusChange();
            });

        isUpdatingClaimStatus = false;

        _closeUpdateStatusModal();
    };

    const toggleStatusDropdown = (event) => {
        showStatusDropdown = !showStatusDropdown;

        const { top, left, height, width } =
            event.target.getBoundingClientRect();
        const dropdownWidth = 220;
        const dropdownHeight = 300;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        const tolerance = 5;

        let dropdownLeft = left + window.scrollX;
        let dropdownTop = top + height + window.scrollY;

        if (dropdownLeft + dropdownWidth > viewportWidth - tolerance)
            dropdownLeft = left + window.scrollX - dropdownWidth + width;

        if (dropdownTop + dropdownHeight > viewportHeight - tolerance)
            dropdownTop = top + window.scrollY - dropdownHeight;

        if (dropdownLeft < tolerance) dropdownLeft = tolerance;
        if (dropdownTop < tolerance) dropdownTop = tolerance;

        dropdownPosition = {
            top: dropdownTop,
            left: dropdownLeft,
        };
    };

    const closeDropdown = () => (showStatusDropdown = false);

    // HELPER FUNCTIONS
    const _openUpdateStatusModal = (status) => {
        if (status == row.claimStatus) return;

        selectedStatus = status;
        showUpdateStatusModal = true;

        closeDropdown();
    };

    const _closeUpdateStatusModal = () => {
        selectedStatus = null;
        showUpdateStatusModal = false;
    };
</script>

 {#if invoiceSent}
    <TableComponentContainer customContainerClass="min-w-[150px]">
        <div class="flex flex-1 w-full gap-x-2 items-center justify-start">
            <!-- on:click={toggleStatusDropdown} -->
        
            <div
                class="flex items-center gap-x-2 p-1 px-2 rounded rounded-full whitespace-nowrap"
                style="background-color: {getClaimStatus(
                    row.claimStatus,
                    'bgColor',
                )}; cursor: default;"
            >
                <div
                    class="w-2 h-2 rounded rounded-full"
                    style="background-color: {getClaimStatus(
                        row.claimStatus,
                        'color',
                    )};"
                />

                <div
                    style="color: {getClaimStatus(
                        row.claimStatus,
                        'color',
                    )}; padding: 2px 2px 0 0;"
                >
                    {getClaimStatus(row.claimStatus)}
                </div>
            </div>
            

            {#if showEncounterPendingClaimTooltip(row)}
                <CustomTooltip
                    contentClass="bg-[#fff] border-none flex-wrap text-left"
                    contentStyle="box-shadow: 4px 4px 13.7px 1px rgba(0, 0, 0, 0.25);"
                    zIndex="20"
                >
                    <img
                        src="/icons/alertIcon_gray.svg"
                        alt="Info Icon"
                        class="w-4 h-4"
                        slot="tooltipTrigger"
                    />

                    <div class="flex flex-col gap-y-1">
                        <p>{getEncounterClaimStatusTooltip(row)}</p>
                    </div>
                </CustomTooltip>
            {/if}
        </div>

        {#if showStatusDropdown}
            <div
                class="dropdown"
                style="top: {dropdownPosition.top}px; left: {dropdownPosition.left}px;"
            >
                <div class="flex flex-1 w-full flex-col gap-y-1">
                    {#each claimStatus as status}
                        <div
                            class="optionsContainer flex w-full cursor-pointer p-2 rounded rounded-lg {status.id ==
                            row.claimStatus
                                ? 'bg-[#634DE3]'
                                : ''}"
                            on:click={() => _openUpdateStatusModal(status.id)}
                        >
                            <div
                                class="flex items-center gap-x-2 p-1 px-2 rounded rounded-full"
                                style="background-color: {status.bgColor};"
                            >
                                <div
                                    class="w-2 h-2 rounded rounded-full"
                                    style="background-color: {status.color};"
                                />

                                <div
                                    style="color: {status.color}; padding: 2px 2px 0 0;"
                                >
                                    {status.type}
                                </div>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>

            <div
                class="fixed top-0 left-0 w-full h-full"
                on:click={closeDropdown}
            />
        {/if}
    </TableComponentContainer>
{/if}

<NotificationModal
    isModalOpen={showUpdateStatusModal}
    title="Update Encounter Claim Status"
    cancelText="Not now"
    closeModal={_closeUpdateStatusModal}
    closeModalFunction={_closeUpdateStatusModal}
    submitText={isUpdatingClaimStatus ? "Updating" : "Update"}
    confirmAction={updateEncounterClaimStatus}
>
    <p class="text-left leading-6 p-4">
        You are about to update the claim status of this encounter to {getClaimStatus(
            selectedStatus,
        )}
    </p>
</NotificationModal>

<style>
    .dropdown {
        position: fixed;
        z-index: 1000;
        background: white;
        border: 1px solid #ccc;
        box-shadow: 4px 4px 13.7px 1px rgba(0, 0, 0, 0.25);
        border-radius: 8px;
        padding: 8px;
        min-width: 220px;
        max-height: 400px;
        overflow-y: auto;
    }

    .optionsContainer:hover {
        background-color: #634de3;
    }
</style>
